


































import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import { ModalState } from '@/models'

@Component({
  components: {
    ValidationObserver,
    ValidationProvider
  }
})
export default class RenameModal extends Vue {
  @Prop({ type: ModalState, required: true })
  readonly modalState!: ModalState

  @Prop({ type: String, required: true })
  readonly data!: string

  @Prop({ type: String, required: true })
  readonly fieldName!: string

  @Prop({ type: String, required: true })
  readonly label!: string

  @Prop({ type: [String, Number], required: true })
  readonly maxlength!: string | number

  isValid = false

  name = ''

  @Watch('data', { immediate: true })
  onDataChange () {
    this.name = this.data
  }

  /**
   * This is a hack because ValidationObserver does not emit a status event
   * and its validate() method returns a Promise.
   */
  setIsValid (valid: boolean) {
    this.isValid = valid && this.name !== this.data
  }

  cancel () {
    this.modalState.reset()

    this.name = this.data

    this.$emit('cancel')
  }

  submit () {
    if (!this.isValid) {
      return
    }

    this.$emit('submit', this.name)
  }

  submitAndClose () {
    this.modalState.isActive = false
    this.submit()
  }
}
